function getEnv() {
  const url = window.location.hostname;
  switch (url) {
    case 'dev.tourconnect.com':
      return 'test';
    case 'staging.tourconnect.com':
      return 'staging';
    case 'contracting.tourconnect.com':
    default:
      return 'prod';
  }
}

export default getEnv();



// WEBPACK FOOTER //
// ./src/app/utils/env.js